import { PublicForm } from "@/components/forms/public-form";

export function TailoredComparisonForm() {
  return (
    <PublicForm
      kind="pricing-comparison"
      submitLabel="Request comparison"
      success={{
        title: "Your request is ready to send",
        body: "We've opened your email app with your comparison request prepared — send it and we'll put one together.",
      }}
    />
  );
}
